import React from "react";
import { Navigate } from "react-router-dom";
const taGuard = (Element) => {
  return (props) => {
    localStorage.getItem("xAuthToken");
    let user = localStorage.getItem("user");
    user = JSON.parse(user);
    if (user.role === "TEACHER_ASSISTANT") {
      return <Element {...props} />;
    } else {
      return <Navigate to="/" {...props} />;
    }
  };
};

export default taGuard;
